import React, { useState } from "react";
import "./contactus.scss";
import { Modal } from "react-bootstrap";
import axios from "axios"; // Import Axios
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { Api_Url } from "../../../utils/apiUrl";

const Contactus = () => {
  const [show, setShow] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [attachment, setAttachment] = useState(null);
  const [attachmentName, setAttachmentName] = useState("");
  const [errorText, setErrorText] = useState("");
  const [errorTextName, setErrorTextName] = useState("");
  const [errorTextMessage, setErrorTextMessage] = useState("");
  const [errorTextAttachment, setErrorTextAttachment] = useState("");
  const [errorTextGeneral, setErrorTextGeneral] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const MAX_FILE_SIZE = 100 * 1024 * 1024; // 100 MB
  const ALLOWED_FILE_TYPES = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "image/gif",
    "image/webp",
    "video/mp4",
    "video/mpeg",
  ];

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      setAttachment(null);
      setAttachmentName("");
      setErrorTextAttachment("");
      return;
    }

    // Validate file size
    if (file.size > MAX_FILE_SIZE) {
      setErrorTextAttachment("File size exceeds 100 MB limit.");
      setAttachment(null);
      setAttachmentName("");
      return;
    }

    // Validate file type (for now accepting common image and video types)
    if (!ALLOWED_FILE_TYPES.includes(file.type)) {
      setErrorTextAttachment("Only image and video files are allowed.");
      setAttachment(null);
      setAttachmentName("");
      return;
    }

    setAttachment(file);
    setAttachmentName(file.name);
    setErrorTextAttachment("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorTextGeneral("");
    
    // Validate required fields
    if (!validateName(name)) {
      setErrorTextName("Please enter a valid name.");
      return;
    }
    if (!validateEmail(email)) {
      setErrorText("Please enter a valid email address.");
      return;
    }
    if (!validateMessage(message)) {
      setErrorTextMessage("Please enter a message.");
      return;
    }

    try {
      setIsLoading(true);
      
      // Create FormData for multipart/form-data
      const formData = new FormData();
      formData.append("name", name);
      formData.append("email", email);
      formData.append("subject", subject);
      formData.append("message", message);
      
      // Append attachment if provided
      if (attachment) {
        formData.append("attachment", attachment);
      }

      const response = await axios.post(`${Api_Url}/contact/contact-us`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      // Clear form
      setName("");
      setEmail("");
      setSubject("");
      setMessage("");
      setAttachment(null);
      setAttachmentName("");
      setErrorText("");
      setErrorTextName("");
      setErrorTextMessage("");
      setErrorTextGeneral("");
      setErrorTextAttachment("");
      setIsLoading(false);
      handleShow();
    } catch (error) {
      console.error("Error:", error);
      setIsLoading(false);
      setErrorTextGeneral(error.response?.data?.message || "Failed to submit the form. Please try again.");
    }
  };

  const validateName = (name) => {
    return name.trim() !== "";
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validateMessage = (message) => {
    return message.trim() !== "";
  };

  return (
    <>
      <Header />
      <section className="contactmain">
        <img src="\assets\career-bg.png" alt="img" className='img-fluid career-bg' />
        <div className="custom-container">
          <div className="main-heading">
            <h2 className="heads">Support</h2>
          </div>
          <div className="innercontact">
            <div className="contactleft">
              <h4 className="contactmainhead">Need help with Queenwars? </h4>
              <p className="contactpara">
                Find answers to common questions or contact our support team and we will get back to you as soon as possible.
              </p>
            </div>
            <div className="contactright">
              <form onSubmit={handleSubmit}>
                <div className="option-field">
                  <h6 className="inputlabel">Full Name *</h6>
                  <input
                    type="text"
                    className={errorTextName ? "contactinput error" : "contactinput"}
                    placeholder="Enter your name"
                    value={name}
                    onChange={(e) => {
                      setName(e.target.value);
                      setErrorTextName("");
                    }}
                  />
                  {errorTextName && (
                    <p
                      className="error-message"
                      style={{
                        color: "#F23C3C",
                        padding: 0,
                      }}
                    >
                      {errorTextName}
                    </p>
                  )}
                </div>
                <div className="option-field">
                  <h6 className="inputlabel">Email Address *</h6>
                  <input
                    type="email"
                    className={errorText ? "contactinput error" : "contactinput"}
                    placeholder="Enter a valid email address"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      setErrorText("");
                    }}
                  />
                  {errorText && (
                    <p
                      className="error-message"
                      style={{
                        color: "#F23C3C",
                        padding: 0,
                      }}
                    >
                      {errorText}
                    </p>
                  )}
                </div>
                <div className="option-field">
                  <h6 className="inputlabel">Subject</h6>
                  <input
                    type="text"
                    className="contactinput"
                    placeholder="Select a topic"
                    value={subject}
                    onChange={(e) => {
                      setSubject(e.target.value);
                    }}
                  />
                </div>
                <div className="option-field">
                  <h6 className="inputlabel">Message *</h6>
                  <textarea
                    className={errorTextMessage ? "contactinputtextarea error" : "contactinputtextarea"}
                    placeholder="Describe your issue in detail"
                    value={message}
                    onChange={(e) => {
                      setMessage(e.target.value);
                      setErrorTextMessage("");
                    }}
                  />
                  {errorTextMessage && (
                    <p
                      className="error-message"
                      style={{
                        color: "#F23C3C",
                        padding: 0,
                      }}
                    >
                      {errorTextMessage}
                    </p>
                  )}
                </div>
                <div className="option-field">
                  <label htmlFor="upload" className="attachfile">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M12.3302 12.15L9.86018 14.62C8.49018 15.99 8.49018 18.2 9.86018 19.57C11.2302 20.94 13.4402 20.94 14.8102 19.57L18.7002 15.68C21.4302 12.95 21.4302 8.51004 18.7002 5.78004C15.9702 3.05004 11.5302 3.05004 8.80018 5.78004L4.56018 10.02C2.22018 12.36 2.22018 16.16 4.56018 18.51" stroke="#DC2BE6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg> {attachmentName ? `${attachmentName}` : 'Attach file'} <span>(optional)</span>
                    <input 
                      type="file" 
                      id="upload" 
                      className="d-none"
                      accept="image/*,video/*"
                      onChange={handleFileChange}
                    />
                  </label>
                  {errorTextAttachment && (
                    <p
                      className="error-message"
                      style={{
                        color: "#F23C3C",
                        padding: 0,
                      }}
                    >
                      {errorTextAttachment}
                    </p>
                  )}
                </div>
                  {errorTextGeneral && (
                    <p
                      className="error-message"
                      style={{
                        color: "#F23C3C",
                        padding: 0,
                      }}
                    >
                      {errorTextGeneral}
                    </p>
                  )}
                <button type="submit" className="submitbtn" disabled={isLoading}>
                  <img src="\assets\btn-bg.png" alt="img" className="img-fluid btn-bg" />
                  {isLoading ? "Submitting..." : "Submit request"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
      <Footer />

      <Modal
        className="thankyoumodal"
        show={show}
        onHide={handleClose}
        centered
      >
        <img src="\assets\modal-bg.png" alt="img" className="img-fluid modal-bg" />
        <Modal.Header closeButton>
          <img src="\assets\modal-header.png" alt="img" className="img-fluid header-bg" />
          <Modal.Title>success</Modal.Title>
          <img onClick={handleClose} src="\assets\close-circle.svg" alt="img" className="img-fluid btn-close-modal" />
        </Modal.Header>
        <Modal.Body>
          <h4>
            Thank you for reaching out. Your request has been received and our support team will contact you shortly.
          </h4>
          <button onClick={handleClose}>
            <img src="\assets\btn-bg.png" alt="img" className="img-fluid btn-bg" />
            OKAY</button>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Contactus;
